// Module Federation requires dynamic imports for the bootstrap
import('./bootstrap')
  .catch(err => console.error('Error loading bootstrap:', err));

